import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconClock, IconTrendingUp } from '@tabler/icons-react';
import { useRef } from 'react';
import { useShowToolTip } from 'common/hooks/useShowToolTip';
import CustomTooltip from 'common/customTooltip';
import ReportOperation from './ReportOperation';

const ReportSummaryItem = ({
  card,
  idx,
  start,
  layout,
  tabValue,
  favoriteReportsCount,
  handleReportClick,
  handleShareClick,
  shouldShowFavorite = true,
  isReports = false,
  carouselConfig
}) => {
  const titleRef = useRef();
  const descRef = useRef();
  const isTitleOverflowing = useShowToolTip(titleRef);
  const isDescOverflowing = useShowToolTip(descRef);

  const descriptionText =
    card.description && String(card.description).trim().length > 0
      ? card.description
      : 'No description available.';

  const { cardWidth } = carouselConfig || { cardWidth: 352 };

  return (
    <Box
      data-carousel-card
      sx={{
        pt: 0,
        pb: 3,
        flex: `0 0 ${cardWidth}px`,
        minWidth: 0,
        scrollSnapAlign: 'start',
      }}>
      <Box
        sx={{
          bgcolor: '#FFF',
          borderRadius: '16px',
          width: '100%',
          height: `${layout.cardHeight}px`,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          boxSizing: 'border-box'
        }}>
        <Box
          sx={{
            borderTop: '1px solid #71767A',
            borderRight: '1px solid #71767A',
            borderLeft: '1px solid #71767A',
            borderBottom: 'none',
            borderRadius: '16px 16px 0 0',
            height: '177px',
            px: '24px',
            pt: '24px',
            pb: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'flex-start',
            flexShrink: 0,
            boxSizing: 'border-box'
          }}>
          {tabValue && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                bgcolor: tabValue === 'recently_viewed' ? '#5173A7' : tabValue === 'needs_attention' ? '#E70057' : '',
                color: tabValue === 'recently_viewed' ? '#FFFFFF' : tabValue === 'needs_attention' ? '#FFFFFF' : '#121A22',
                fontSize: 12,
                fontWeight: 500,
                padding: tabValue === 'recently_viewed' || tabValue === 'needs_attention' ? '4px' : '0px',
                borderRadius: '4px',
                justifyContent: 'center',
                lineHeight: 1.6,
                flexShrink: 0,
                margin: "2px 0px"
              }}>
              {tabValue === 'recently_viewed' && <IconClock size={12} color="#FFFFFF" />}
              {tabValue === 'needs_attention' && <IconTrendingUp size={12} color="#FFFFFF" />}
              <Typography
                sx={{
                  fontFamily: 'Rubik',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: 12,
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  letterSpacing: '0.36px',
                  textTransform: 'uppercase',
                  pt: tabValue === 'saved' ? '4px' : '0px',
                  lineHeight: "12px"
                }}>
                {tabValue === 'recently_viewed' ? 'Recent' : tabValue === 'needs_attention' ? 'Needs Attention' : `${favoriteReportsCount} ${favoriteReportsCount === 1 ? 'Save' : 'Saves'}`}
              </Typography>
            </Box>
          )}
<CustomTooltip
  title={card.displayText || 'Report Title'}
  disableHoverListener={!isTitleOverflowing}
  padding="16px"
  borderRadius="8px 0px 8px 8px"
  topBorderRadius="8px 8px 0px 8px"
  width="308px"
  placement="bottom-end"
  popperProps={{ modifiers: [{ name: 'offset', options: { offset: [-16, 0] } }] }}
>
            <Typography
              ref={titleRef}
              component="span"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                fontFamily: 'Rubik',
                fontSize: '16px',
                fontWeight: 600,
                color: '#000',
                lineHeight: '24px',
                maxHeight: '48px',
                flexShrink: 0,
              }}>
              {card.displayText || 'Report Title'}
            </Typography>
          </CustomTooltip>

          <CustomTooltip title={descriptionText} disableHoverListener={!isDescOverflowing} padding="16px" borderRadius="8px 0px 8px 8px" topBorderRadius="8px 8px 0px 8px" width="308px" placement="bottom-end" popperProps={{ modifiers: [{ name: 'offset', options: { offset: [-16, 0] } }] }}>
            <Box
              ref={descRef}
              sx={{
                bgcolor: '#FFF',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontFamily: 'Noto Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '21px',
                minHeight: '63px',
                maxHeight: '63px',
                color: '#121A22',
                textAlign: 'left'
              }}>
              {descriptionText}
            </Box>
          </CustomTooltip>
        </Box>

        <Box
          sx={{
            borderRight: '1px solid #71767A',
            borderBottom: '1px solid #71767A',
            borderLeft: '1px solid #71767A',
            borderTop: 'none',
            borderRadius: '0 0 16px 16px',
            height: '68px',
            py: '20px',
            px: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            flexShrink: 0,
            boxSizing: 'border-box'
          }}>
          <ReportOperation
            card={card}
            handleReportClick={handleReportClick}
            handleShareClick={handleShareClick}
            shouldShowFavorite={shouldShowFavorite}
            containerPx={0}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ReportSummaryItem;
